import classNames from 'classnames';

import './index.scss';

interface Props {
  value: string;
  large?: boolean;
}

export function Ribbon({ value, large = false }: Props) {
  return (
    <span
      className={classNames('Ribbon', {
        'Ribbon--large': large,
      })}
    >
      <span>{value}</span>
    </span>
  );
}
